import { collection, doc, serverTimestamp, setDoc } from "firebase/firestore";

import { db } from "./firebase";

export const sendEmailRequest = async (
  userId: string,
  emailTemplateId: string,
  metaData?: {
    key: string;
    value?: string;
  }[]
) => {
  const emailDoc = doc(collection(db, "email_requests"));
  await setDoc(emailDoc, {
    createdAt: serverTimestamp(),
    to: userId,
    template_id: emailTemplateId,
    meta_data: metaData || [],
  });
};

export const sendEmailRequestToAdmin = async (
  emailTemplateId: string,
  metaData?: {
    key: string;
    value?: string;
  }[]
) => {
  const emailDoc = doc(collection(db, "email_requests"));
  await setDoc(emailDoc, {
    createdAt: serverTimestamp(),
    to: process.env.NEXT_PUBLIC_ADMIN_EMAIL,
    template_id: emailTemplateId,
    meta_data: metaData || [],
  });
};
